<template>
    <header>
            <div class="logo pt-4">
                <img src="../../assets/images/logo.png">
            </div>

    </header>
</template>